import module from 'nominas/nomina/module.js'

const schema = {
  status_visible: 'boolean',
  status_calculado: 'boolean',
  status_acumulado: 'boolean',
  eliminable: 'boolean',
  principal: {
    fecha: 'date',
    fecha_final: 'date',
    fecha_inicial: 'date',
    fecha_pago: 'date',
    calculo_fecha: 'timestamp',
    acumulado_fecha: 'timestamp',
  },
  sa: {
    subtotal: 'number',
    impuestos: 'number',
    total: 'number',
  },
  op: {
    subtotal: 'number',
    impuestos: 'number',
    total: 'number',
  },
}

export class NominasNominaInformacionService {
  constructor ($http) {
    this.$http = $http
  }

  get (idProyecto, idNomina) {
    return this.$http.get('/api/nominas/nomina/informacion', {
      params: {idEmpresa: idProyecto, idNomina: idNomina},
      schema,
      cache: 'nominas',
    })
  }
}

module.service('NominasNominaInformacion', NominasNominaInformacionService)



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Informacion.js